import '.iq{display:inline-block;}.ssr-plugin'
import '.ir{margin-top:1.5rem;}.ssr-plugin'
import '.au{font-size:0.875rem;}.ssr-plugin'
import '.is{color:var(--palette-blue-500);}.ssr-plugin'
import '.hm{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="iq ir au is hm"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
